<template>
    <b-container>
        <b-modal
            v-model="openUpdateModal"
            size="xl"
            header-bg-variant="dark"
            header-text-variant="light"
            no-close-on-backdrop
            no-close-on-esc
            hide-header-close
            >
            
            <template v-slot:modal-title>
                <div class="pb-2">{{item.nombre}}</div>
            </template>
            <b-row class="my-1 justify-content-md-center">
                <b-col sm="3">
                    <b-img :src="item.imagen" width="200" height="200" fluid alt="Fluid image"></b-img>
                </b-col>
                <b-col sm="5">
                    <div class="pb-2">
                        <label for="input-live"><strong>Código:</strong></label>
                        <b-form-input v-model="item.codigo" placeholder="Referencia" readonly></b-form-input>
                    </div>
                    <div>
                        <label for="input-live"><strong>Tipo de precio:</strong></label>
                        <b-form-group v-slot="{ ariaDescribedby }">
                            <b-form-radio v-model="tipo_precio" :aria-describedby="ariaDescribedby" value="1">Precio fijo</b-form-radio>
                            <b-form-radio v-model="tipo_precio" :aria-describedby="ariaDescribedby" value="2">% Rentabilidad</b-form-radio>
                        </b-form-group>
                        
                    </div>
                    <label for="input-live"><strong>Precio Personalizado:</strong></label>
                    <div v-if="tipo_precio == 1">
                        
                        <b-input-group prepend="$" append="COP">
                            <b-form-input v-model="item.precio" type="number"  placeholder="Precio Personalizado"></b-form-input>
                        </b-input-group>
                        <b-badge v-if="item.precio < item.precio" variant="danger">
                            Este precio es menor que el del proveedor.
                        </b-badge>
                    </div>
                    <div v-else>
                        <b-input-group prepend="%">
                            <b-form-input v-model="item.precio" type="number"  placeholder="Precio Personalizado"></b-form-input>
                        </b-input-group>
                        <b-badge v-if="item.precio < 1 || item.precio > 99" variant="danger">
                            El porcentaje de rentabilidad debe estar entre 1 y 99
                        </b-badge>
                    </div>
                </b-col>
            </b-row>
            <template v-slot:modal-footer>
                <b-button variant="danger" @click.prevent="$emit('close-modal')">
                    Cancelar
                </b-button>
                <b-button variant="success" @click.prevent="updatePriceItem(item)">
                    Actualizar
                </b-button>
            </template>
        </b-modal>
    </b-container>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
    props: {
        item: {
            type: Object
        },
        openUpdateModal: {
            type: Boolean
        }
    },
    data(){
        return{
            precio: '',
            tipo_precio: 1,
            
        }
    },
    watch: {
        openUpdateModal: function () {
            this.tipo_precio = this.item.tipo_precio;
        }
    },
    methods:{
        ...mapMutations(['setLoading']),
        async updatePriceItem(datos){
            this.setLoading(true)
            let id     = datos.id;
            let precio = datos.precio;
            let tipo_precio = this.tipo_precio;
            let data   = {id, precio, tipo_precio}
            await this.$conectar.post('/precios-personalizados/update-personalize-price', data)
            .then(response =>{
                if (response.data.error == false) { 
                    this.$emit('close-update-modal');
                    this.precio = '';
                    this.$bvToast.toast(response.data.message, {
                        title: "Respuesta del servidor",
                        variant: "success",
                        solid: true
                    })
                }else{
                    this.$bvToast.toast(response.data.message, {
                        title: "Respuesta del servidor",
                        variant: "danger",
                        solid: true
                    })
                }
            })
            .catch(error => {
                this.$bvToast.toast("Parece que hubo un error en el servidor", {
                    title: "Respuesta del servidor",
                    variant: "danger",
                    solid: true
                })
                console.log(error);
            })
            this.setLoading(false)
        },
        
    }
}
</script>